<template>
  <select v-if="options" v-model="checkValue" :disabled="disabled">
    <option v-for="opt in options" :key="opt.value" :value="opt.value">{{opt.label}}</option>
  </select>
</template>
<script lang="ts">
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
  name: "SelectBoxReactiveRenderer",
  setup(props: any) {
    const { params } = toRefs(props);

    const options = params.value.options;
    const disabled = !!params.value.disabled;
    const checkValue = computed({
      get: () => params.value.value,
      set: (v) => {
        params.value.node.setDataValue(params.value.column.colId, parseValueByColId(params.value.column.colId,v));
      },
    });

    const parseValueByColId = (colId : string, v : any) => {
      switch(colId) {
        case 'userLvl': {
          return Number(v)
        }
        default: return v;
      }
    }

    return {
      checkValue,
      options,
      disabled,
    };
  },
});
</script>
